import { JstDate } from '../../../core/time/business-time';
import { MemberState } from './registration-model';
import { createQuestionaryResult } from '../../../shared/utils/member-helpers';

export type RegistrationKind = 'new_membership' | 'temporary_registration' | 'main_registration';
export interface RegistrationOptions { invoiceDate: Date | null; invoiceHtml: string; hasImages: boolean; inStudio: boolean; clockPeriod?: string; }
export interface RegistrationResult { memberId: number; gmoCreateError: boolean; emailSent: boolean; imageKey?: string; }
export interface InvoiceLine { title: string; amount: number; }
export interface RegistrationQuote { firstInvoice: InvoiceLine[]; firstInvoiceDate: string; total: number; }
export function isRecord(value: unknown): value is Record<string, unknown> { return !!value && typeof value === 'object' && !Array.isArray(value); }

/** Keep the legacy billing boundary: the eleventh day at 06:00 JST. */
export function firstInvoiceDate(start: string, now: readonly (string | number)[]): Date {
  const split = start.split('-').map(Number);
  const sameDay = Number(now[2]) === split[2];
  const modify = sameDay ? (split[2] === 11 ? (Number(now[3]) >= 6 ? 1 : 0) : (split[2] > 11 ? 1 : 0)) : (split[2] >= 11 ? 1 : 0);
  return new JstDate(split[0], split[1] + modify, 1);
}

export function registrationPayload(member: MemberState, kind: RegistrationKind, options: RegistrationOptions): Record<string, unknown> {
  const json = JSON.parse(JSON.stringify(member)) as Record<string, any>;
  if (member.desiredStartDate) json['desiredStartDate'] = member.desiredStartDate.id + 'T00:00:00+09:00';
  if (kind !== 'temporary_registration' && member.tmp.firstInvoice && options.invoiceDate) {
    const d = options.invoiceDate;
    json['firstInvoice'] = {
      firstInvoiceDate: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T00:00:00+09:00`,
      keyFee: member.tmp.firstInvoice[0]?.amount, firstMonthFee: member.tmp.firstInvoice[1]?.amount,
      secondMonthFee: member.tmp.firstInvoice[2]?.amount, monthlyFee: member.tmp.firstInvoice[3]?.amount,
      html: options.invoiceHtml || undefined,
    };
  }
  if (kind !== 'main_registration' || member.status === 6) json['questionaryResult'] = createQuestionaryResult(member);
  if (kind === 'new_membership') {
    json['status'] = member.studioPlanId === 999999999 ? 6 : 4;
    json['isWebRegister'] = options.inStudio ? 1 : 0;
    json['uploadImg'] = options.hasImages;
    if (member.tmp.visitNote) json['visitNote'] = member.tmp.visitNote;
  } else if (kind === 'temporary_registration') {
    json['status'] = 5; json['isWebRegister'] = 1;
  } else json['status'] = 4;
  // API uses token/name only. PAN, expiry and security code are never registration DTOs.
  json['cc'] = { name: member.cc.name, token: member.cc.token };
  delete json['tmp'];
  return json;
}
